import DefaultApiService from "./default";

const baseByRole = (role) =>
  role === "Supervisor"
    ? "SLN/Supervisor/ProjectAssignments"
    : "SLN/Contractor/ProjectAssignments";

const unwrapPayload = (res) => res?.data ?? res ?? null;

const ProjectAssignmentsApi = {
  getMyAssignments: async (role) => {
    const res = await DefaultApiService.getCustomeApi(
      `${baseByRole(role)}/GetMyAssignments`
    );
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res) || [],
    };
  },

  acceptAssignment: async (role, assignmentId) => {
    const res = await DefaultApiService.postApi(`${baseByRole(role)}/Accept`, {
      assignmentId,
    });
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },

  rejectAssignment: async (role, assignmentId, reason) => {
    const res = await DefaultApiService.postApi(`${baseByRole(role)}/Reject`, {
      assignmentId,
      reason,
    });
    return {
      ok: res?.isSuccess !== false,
      message: res?.message || "",
      data: unwrapPayload(res),
    };
  },
};

export default ProjectAssignmentsApi;
